require('jquery');

//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/affix');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/alert');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/button');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/carousel');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse');
require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/dropdown');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/tooltip');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/popover');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/scrollspy');
//require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/tab');
require('imports?jQuery=jquery!../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition');



/** WEBPACK FOOTER **
 ** ./js/bootstrap.js
 **/